var resizeImage = (file, maxWidth, maxHeight, mimeString) => {
  return new Promise((resolve) => {
    var crop = true;

    // Create an image
    var img = document.createElement("img");
    // Create a file reader
    var reader = new FileReader();
    // Set the image once loaded into file reader

    mimeString = mimeString ? mimeString : "image/jpeg";

    reader.onload = (e) => {
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.getContext("2d").drawImage(img, 0, 0);

        var width = img.width;
        var height = img.height;

        var landscape = width > height;

        var x = 0,
          y = 0;
        if (crop) {
          height = landscape ? maxHeight : (maxWidth / img.width) * img.height;
          width = landscape ? (maxHeight / img.height) * img.width : maxWidth;
          y = -((height - maxHeight) / 2);
          x = -((width - maxWidth) / 2);
        } else {
          height = landscape ? (maxWidth / width) * height : maxHeight;
          width = landscape ? maxWidth : (maxHeight / height) * width;
        }

        /* if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        } */
        canvas.width = maxWidth;
        canvas.height = maxHeight;

        canvas.getContext("2d").drawImage(img, x, y, width, height);

        var dataURI = canvas.toDataURL(mimeString);

        var byteString;
        if (dataURI.split(",")[0].indexOf("base64") >= 0)
          byteString = atob(dataURI.split(",")[1]);
        else byteString = unescape(dataURI.split(",")[1]);

        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        resolve({
          blob: new Blob([ia], { type: mimeString }),
          dataURI: dataURI,
        });
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

export { resizeImage };
